/**
 * Get current access token from storage (used by usage session APIs and others).
 * No dependency on useService to avoid circular imports.
 */
import CryptoJS from 'crypto-js';

export function getAccessToken() {
  try {
    const serviceAcceptor = localStorage.getItem('service_acceptor');
    const serviceProvider = localStorage.getItem('service_provider');
    if (!serviceAcceptor || !serviceProvider) return null;
    const decrypted = JSON.parse(
      CryptoJS.AES.decrypt(serviceAcceptor, serviceProvider).toString(CryptoJS.enc.Utf8)
    );
    return decrypted.access_token || null;
  } catch {
    return null;
  }
}
